export enum LevelType {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success'
}
